import React, { useEffect, useMemo, useState } from "react";
import { HeaderPage } from "../base/headerPage";
import "./index.scss";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartSeriesLabels } from "@progress/kendo-react-charts";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
//import { useApproveDashboard } from './index.hook'
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataTable from "src/components/dataTable";
import { LoadingPanel } from "src/components/loadingPanel";
import { getDateRangeByPeriod, getMonthDateRange } from "../providerPayRequestDashboard/utils/dateUtils";
import ProviderListBox from "./components/ProviderListBox";
import PayRequestOverviewBox from "./components/PayRequestOverviewBox";
import AnnouncementBox from "./components/AnnouncementBox";
import useApproverDashboardApi from "./index.hook";
import { getUserCredential } from "src/lib/cookies";
import { transformDateTime } from "src/lib/date-time.util";
import { API_CONSTANTS } from "./constants";
import { getEndDate, getStartDate } from "src/utils/utils";
import { GetSystemConfigDataByCode } from "src/lib/common-service";

const ApproverDashboard = (restProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const providerListRef = React.useRef();
  const cookiesData = getUserCredential();
  const [list, Action] = useApproverDashboardApi();

  const { statusCount, isPendingRequestsLoading } = list;
  const [periodFilter, setPeriodFilter] = useState("PYTD");
  const [holdEnabled, setHoldEnabled] = useState(undefined);

  const { startDate, endDate } = useMemo(() => getDateRangeByPeriod(periodFilter), [periodFilter]);

  // const startDateString = startDate
  //     ? transformDateTime({
  //           date: startDate,
  //           format: 'YYYY-MM-DD',
  //           includeTime: true,
  //       })
  //     : null
  // const endDateString = endDate
  //     ? `${transformDateTime({
  //           date: endDate,
  //           format: 'YYYY-MM-DD',
  //           includeTime: false,
  //       })} 23:59:59`
  //     : null

  const startDateString = startDate ? getStartDate(startDate) : null;
  const endDateString = endDate ? getEndDate(endDate) : null;

  useEffect(() => {
    const payload = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_approver_mstr_key: cookiesData.out_user_id.toString(),
      in_start_date: startDateString,
      in_end_date: endDateString,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
    };

    providerListRef?.current?.resetFilter();

    Action.fetchGroupStatusForApprover(payload);
  }, [periodFilter]);

  useEffect(() => {
    const loadHoldPref = async () => {
      const prefs = await GetSystemConfigDataByCode(
        {
          in_tenant_id: cookiesData.out_tenant_id,
          pref_code: ["sys_hold_status_notif"],
        },
        history,
        dispatch
      );
      setHoldEnabled(prefs?.sys_hold_status_notif === "1");
    };
    loadHoldPref();
  }, [cookiesData.out_tenant_id, dispatch, history]);

  return (
    <>
      <div className="Main dashboard">
        <div className="content">
          <div className="content-head">
            <HeaderPage
              pageProps={restProps}
              headerConfig={{
                title: "Approver Dashboard",
                id: "approver-dashboard",
              }}
            />
          </div>

          <div className="content-body messages-section">
            <div className="approver-container">
              <AnnouncementBox statusCount={statusCount} startDate={startDate} endDate={endDate} />

              <div
                className="approverdashboard-container"
                style={
                  {
                    // opacity: isLoadStatus ? 0.4 : 1,
                    // pointerEvents: isLoadStatus ? 'none' : 'auto',
                  }
                }
              >
                <div className="messages-left-panel">
                  <div className="left-content">
                    <PayRequestOverviewBox
                      periodFilter={periodFilter}
                      setPeriodFilter={setPeriodFilter}
                      statusCount={statusCount}
                      startDate={startDate}
                      endDate={endDate}
                      isPendingRequestsLoading={isPendingRequestsLoading}
                      holdEnabled={holdEnabled}
                    />
                  </div>
                </div>
                <div className="messages-right-panel">
                  <div className="right-content">
                    <ProviderListBox ref={providerListRef} startDate={startDate} endDate={endDate} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(ApproverDashboard);
